module.exports = __webpack_public_path__ + "img/stations.88ffa7d3.svg";